import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { createOpenAIModalCommand } from '../decoration/actions';
import { aiEventHubPluginKey } from './ai-event-hub-plugin-key';
import { eventHub } from './event-hub';
import { EventHubPrompt } from './types';
import { firePromptConfigNotFoundError } from './utils/analytic-utils';
import { getConfigItem } from './utils/config-utils';
import { findEditorIdFromView } from './utils/isolated-utils';
import { handleStreamingService } from './utils/streaming-utils';
export var createAIEventHubPlugin = function createAIEventHubPlugin(options) {
  var aiGlobalOptIn = options.aiGlobalOptIn;
  return new SafePlugin({
    key: aiEventHubPluginKey,
    view: function view(editorView) {
      var currentEditorView = editorView;
      var _eventHub$subscribe = eventHub.subscribe({
          event: 'start prompt',
          callback: function callback(data) {
            var editorId = findEditorIdFromView(currentEditorView);
            if (editorId === data.targetEditorId) {
              var _currentEditorView = currentEditorView,
                state = _currentEditorView.state,
                dispatch = _currentEditorView.dispatch;
              var configItem = getConfigItem(data.prompt, options.editorPluginAIProvider, data.adjustSelection, data.prompt === EventHubPrompt.IssueReformatter ? data.additionalPayloadDataIssueReformatter : undefined);
              if (!configItem) {
                firePromptConfigNotFoundError({
                  dispatch: dispatch,
                  editorView: currentEditorView,
                  prompt: data.prompt,
                  promptText: data.prompt === EventHubPrompt.CustomPrompt ? data.promptText : undefined,
                  adjustSelection: data.adjustSelection
                });
                return;
              }
              var params = {
                state: state,
                configItem: configItem,
                lastTriggeredFrom: data.analyticSourceId,
                aiGlobalOptIn: aiGlobalOptIn,
                adjustSelection: data.adjustSelection,
                initialPrompt: data.prompt === EventHubPrompt.CustomPrompt ? data.promptText : undefined
              };
              if (data.hideModal) {
                handleStreamingService({
                  getIntl: options.getIntl,
                  currentEditorView: currentEditorView,
                  editorPluginAIProvider: options.editorPluginAIProvider,
                  configItem: configItem,
                  streamingCallback: data.streamingCallback,
                  api: options.api,
                  analyticSourceId: data.analyticSourceId
                });
              } else {
                var openAIModalCommand = createOpenAIModalCommand(params);
                openAIModalCommand(state, dispatch);
              }
            }
          }
        }),
        unsubscribe = _eventHub$subscribe.unsubscribe;
      return {
        update: function update(newEditorView) {
          currentEditorView = newEditorView;
        },
        destroy: function destroy() {
          unsubscribe();
        }
      };
    }
  });
};